<template>
  <div>
    <apexchart
      width="100%"
      height="500"
      type="line"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "OQProducerBasicProductionGraphic",
  components: {
    apexchart: VueApexCharts,
  },
  props: ["series_data_prop", "x_categories_prop"],
  data: function () {
    return {
      series: this.series_data_prop,
      chartOptions: {
        chart: {
          height: 500,
          type: "line",
          toolbar: {
            show: true,
          },
        },
        colors: ["#38B61E", "#DC2626"],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val + " kg";
          },
          offsetY: 0,
          style: {
            fontSize: "14px",
          },
        },
        stroke: {
          curve: "straight",
          width: [0, 2]
        },
        title: {
          text: " ",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        xaxis: {
          categories: this.x_categories_prop,
          title: {
            text: "Campaña",
          },
        },
        yaxis: {
          title: {
            text: "Kilos",
          },
        },
        legend: {
          position: "bottom",
          horizontalAlign: "right",
          floating: true,
          offsetY: 0,
          offsetX: 0,
        },
      },
    };
  },
};
</script>